// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:ad44a8ee-b696-43ab-9ebb-da0fc2969c00",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_rmhzsIjVt",
    "aws_user_pools_web_client_id": "24i8l2sdnvk4rvdc6rm5keqd29",
    "oauth": {}
};


export default awsmobile;
